module.exports = __webpack_public_path__ + "img/construction.30b2b4a3.svg";